import React, { Component } from "react";
import { routes } from "../../constants/routes";
import ProtectedRoute from "../ProtectedRoute/protected-route";
import { Route, Switch } from "react-router";
import MissingRight from "./missing-right";

export default class Body extends Component {
  render() {
    return (
      <div>
        <Switch>
          {routes.map((current) => {
            return (
              <ProtectedRoute
                socket={this.props.socket}
                path={current.path}
                component={current.component}
                key={current.path}
              />
            );
          })}
          <Route path="/mol/missing-right" component={MissingRight} />
        </Switch>
      </div>
    );
  }
}
